module.exports = __webpack_public_path__ + "44483b6c4083f9503e075863fa67f786.png";


/*****************
 ** WEBPACK FOOTER
 ** ./blog/how-facebooks-graphql-will-change-backend-development/GraphQL_logo.png
 ** module id = 342
 ** module chunks = 0
 **/